<template>
  <div class="header center">
    <div class="logo_img">
      <!-- LOGO -->
      <a href="index.html" title="中国工程师协会  Chinese Institute of Engineers">
        <img src="../assets/css/images/201910171402462461.png"
             alt="中国工程师协会  Chinese Institute of Engineers"/></a>
    </div>
    <!--导航-->
    <div class="navbox">
      <ul class='nav'>
        <li class='menu_li'><a href="/">首页</a></li>
        <li class='menu_li'><a href="/#/huiYuanZhongXin">会员中心</a></li>
        <li class='menu_li'><a href="/#/xieHuiGaiKuang">协会概况</a></li>
        <li class='menu_li'><a href="/#/xinWenZiXun">新闻资讯</a></li>
        <li class='menu_li'><a href="/#/hangYeDongTai">行业动态</a></li>
        <li class='menu_li'><a href="/#/xinXiZhongXin">信息中心</a></li>
      </ul>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header"
}
</script>

<style scoped>
a {
  font-weight: bold;
}
</style>